import { render, staticRenderFns } from "./DashFuncionarioVarejoRankingRecebimento.vue?vue&type=template&id=1c64a4e3"
import script from "./DashFuncionarioVarejoRankingRecebimento.vue?vue&type=script&lang=js"
export * from "./DashFuncionarioVarejoRankingRecebimento.vue?vue&type=script&lang=js"
import style0 from "./DashFuncionarioVarejoRankingRecebimento.vue?vue&type=style&index=0&id=1c64a4e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports